var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Likert',{attrs:{"items":_vm.items,"value":_vm.singleValue,"value-key":"value","label-key":"text"},on:{"input":function($event){return _vm.emitSingleValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }